
export const status = [
  { value: 'ACTIVE' },
  { value: 'INACTIVE' },
];

export const yesNo = [
  { value: 'YES' },
  { value: 'NO' },
];
